import { makeStyles } from "@material-ui/core/styles";

export const schedulingColumnSelectorStyles = makeStyles((theme) => ({
  wrapper: {
    minWidth: '300px',
    width: '15vw',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  heading: {
    color: theme.palette.primary.main
  },
  body: {
    padding: '10px',
  },
  column: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginTop: '5px',
    borderBottom: '1px solid #F0F4E8'
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '10px'
  },
  button : {
    padding: '10px',
    width: '100%',
  },
  cancelButton: {
    marginRight: '10px'
  }
}));
